import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Game } from '../../../../../backend/src/games/entities/game.entity';
import { Material } from '../../../../../backend/src/materials/entities/material.entity';
import { BgfComponent } from '../../../../../backend/src/components/entities/component.entity';
import { ProductGroup } from '../../../../../backend/src/product-group/entities/product-group.entity';

@Component({
  selector: 'app-bgf-auto-selector',
  templateUrl: './bgf-auto-selector.component.html',
  styleUrl: './bgf-auto-selector.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BgfAutoSelectorComponent),
      multi: true
    }
  ]
})
export class BgfAutoSelectorComponent implements ControlValueAccessor {

  @Input() instanceType: "component" | "game" | "material" | "product-group";
  @Input() placeholder: string = "Keresés...";
  @Output('valueChanged') valueChanged: EventEmitter<any> = new EventEmitter(); 
  selectedInstance: string | any;
  onChange: any = () => {};
  onTouched: any = () => {};
  fetchingInstances: boolean = false;
  instanceList: Game[] | Material[] | BgfComponent[] | ProductGroup[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
      if(!this.instanceType) {
        throw("[BgfAutoSelectorComponent] InstanceType missing!");
      }
  }

  onOptionSelected(e: any) {
    this.valueChanged.emit(e);
  }

  writeValue(value: any): void {
    this.selectedInstance = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // If you want to implement disabling functionality
  }

  fetchInstances() {
    switch (this.instanceType) {
        case "game":
            this.fetchGames();
            break;
        case "component":
            this.fetchComponents();
            break;
        case "material":
            this.fetchMaterials();
            break;
        case "product-group":
            this.fetchProductGroups();
            break;
        default:
            break;
    }
  }

  fetchComponents() {
    this.fetchingInstances = true;
    this.http.get<any[]>(`components?filter=${this.selectedInstance}`).subscribe({
      next: (fetchedComponentList) => {
        this.instanceList = fetchedComponentList;
        this.fetchingInstances = false;
      },
      error: (e) => {
        console.log(e);
        this.fetchingInstances = false;
      }
    })
  }

  fetchGames() {
    this.fetchingInstances = true;
    this.http.get<Game[]>(`games?filter=${this.selectedInstance}`).subscribe({
      next: (games) => {
        this.instanceList = games;
        this.fetchingInstances = false;
      },
      error: (e) => {
        console.log(e);
        this.fetchingInstances = false;
      }
    })
  }

  fetchProductGroups() {
    this.fetchingInstances = true;
    this.http.get<ProductGroup[]>(`product-group?filter=${this.selectedInstance}`).subscribe({
      next: (productGroup) => {
        this.instanceList = productGroup;
        this.fetchingInstances = false;
      },
      error: (e) => {
        console.log(e);
        this.fetchingInstances = false;
      }
    })
  }

  fetchMaterials() {
    this.fetchingInstances = true;
    this.http.get<Material[]>(`materials?filter=${this.selectedInstance}`).subscribe({
      next: (materials) => {
        this.instanceList = materials;
        this.fetchingInstances = false;
      },
      error: (e) => {
        console.log(e);
        this.fetchingInstances = false;
      }
    })
  }

  displayFn(instance: Game | Material | BgfComponent): string {
    switch (this.instanceType) {
        case "game":
            const game = instance as Game;
            return game && game.name ? game.name : '';
        case "component":
            const component = instance as BgfComponent;
            return  component && component.name ? `${component.name} - ${component.sku}` : '';
        case "material":
            const material = instance as Material;
            return material && material.name ? material.name : '';
        case "product-group":
            const productGroup = instance as Material;
            return productGroup && productGroup.name ? productGroup.name : '';
        default:
            return "";
    }
    
  }


}
